export default __webpack_public_path__ + "static/media/icon-coin-flow.dc2db7a5.svg";